import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const InstallationGuide = () => {
  const [platform, setPlatform] = useState('');

  useEffect(() => {
    const platform = window.navigator.userAgent.toLowerCase();
    if (platform.includes('android')) {
      setPlatform('android');
    } else if (platform.includes('iphone')) {
      setPlatform('ios');
    } else {
      setPlatform('other');
    }
  }, []);

  const steps = {
    android: [
      'Toca el ícono de tres puntos verticales en la esquina superior derecha.',
      'Selecciona "Instalar aplicación".',
      'Confirma la instalación tocando "Instalar".'
    ],
    ios: [
      'Toca el ícono de compartir en la barra de navegacion',
      'Selecciona "Agregar a la pantalla de inicio".',
      'Confirma la instalación tocando "Agregar".'
    ],
    other: [
      'Accede al menú de opciones del navegador.',
      'Busca y selecciona "Agregar a la pantalla de inicio" o una opción similar.',
      'Sigue las instrucciones para confirmar la instalación.'
    ]
  };

  const getImage = (type) => {
    switch (type) {
      case 'android':
        return '/android-chrome.png';
      case 'ios':
        return '/ios-safari.png';
      default:
        return '/android-chrome.png';
    }
  };

  const renderInstructions = () => {
    const instructionSteps = steps[platform] || steps['other']; 
    console.log(platform);

    return (
      <Box textAlign="center">
        <List>
          {instructionSteps.map((step, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={step} />
            </ListItem>
          ))}
        </List>
        <img src={getImage(platform)} alt={`Instrucciones ${platform}`} style={{ width: '100%', maxWidth: '500px', marginTop: '20px' }} />
      </Box>
    );
  };

  return (
    <Container maxWidth="md" sx={{ padding: 2 }}>
      <Box my={4}>
        <Typography variant="h5" gutterBottom align="center">
          ¿Cómo instalarla?
        </Typography>
        {renderInstructions()}
      </Box>
    </Container>
  );
};

export default InstallationGuide;
